/**
 * PURPOSE: Renderizar un casillero compacto dentro de la llave del evento 17.
 * RESPONSIBILITIES: Mostrar la etiqueta del participante según moodName (FTR-0006:
 *   moodName 1 => abrev; en otro caso displayName || Institution.name) o el origen pendiente.
 * COLLABORATORS: BracketMatchCard.jsx y BracketConnectorLayer.jsx.
 * ROUTE: frontend/src/components/FullScreenModal/FullScreenEliminatoria/Bracket/BracketSlot.jsx
 */
import React from "react";
import { getParticipantLabel } from "../../../../utils/participantDisplayName.js";

const SOURCE_STYLE = {
  BEST_LOSER: "border-amber-200 bg-amber-50 text-amber-900",
  DIRECT: "border-blue-200 bg-blue-50 text-blue-900",
  LOSER: "border-violet-200 bg-violet-50 text-violet-900",
  WINNER: "border-slate-200 bg-slate-50 text-slate-700",
  SEED: "border-slate-200 bg-white text-slate-800",
};

export default function BracketSlot({ slot, moodName }) {
  const participant = slot?.participant || null;
  const sourceType = slot?.sourceType || "SEED";
  const pendingStyle = SOURCE_STYLE[sourceType] || SOURCE_STYLE.SEED;
  // FTR-0006: moodName 1 => abrev; otro caso => displayName || name.
  // El nombre de la institución queda como respaldo si el backend aún no expone abrev/displayName.
  const visibleName =
    getParticipantLabel(participant, moodName) ||
    participant?.institution?.name ||
    slot?.sourceLabel ||
    "Por definir";

  return (
    <div
      data-slot-side={slot?.side}
      className={`flex min-h-[44px] items-center gap-2.5 rounded-lg border px-2.5 py-2 ${
        participant ? "border-slate-200 bg-white" : pendingStyle
      }`}
    >
      <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-slate-200">
        {participant?.institution?.logo ? (
          <img
            src={participant.institution.logo}
            alt={visibleName}
            className="h-full w-full object-contain p-1"
          />
        ) : (
          <span className="text-sm font-semibold text-slate-300">—</span>
        )}
      </div>

      <p className="min-w-0 flex-1 truncate text-[13px] font-semibold">
        {visibleName}
      </p>
    </div>
  );
}
